module.exports = __webpack_public_path__ + "static/media/logo.100ea8d1.png";